const animation = {
  name: "animation",
  path: "/animation",
  title: "animation",
  description: "Utilities for controlling animation classes and keyframes.",
  value: {
    "animation": {
      "animate-spin": "var(--animate-spin)", 
      "animate-ping": "var(--animate-ping)", 
      "animate-pulse": "var(--animate-pulse)",
      "animate-bounce": "var(--animate-bounce)",
      "animate-none": "none",
      "animate-[<value>]": "<value>"
    }
  },
  exampleData: [
    {
      example: {
        code: `<button class="animate-spin bg-color-blue-500 text-color-white font-bold py-2 px-4 rounded">
  Spin
</button>
<button class="animate-ping bg-color-green-500 text-color-white font-bold py-2 px-4 rounded mt-4">
  Ping
</button>
<button class="animate-pulse bg-color-yellow-500 text-color-white font-bold py-2 px-4 rounded mt-4">
  Pulse
</button>
<button class="animate-bounce bg-color-red-500 text-color-white font-bold py-2 px-4 rounded mt-4">
  Bounce
</button>
<button class="animate-none bg-color-gray-500 text-color-white font-bold py-2 px-4 rounded mt-4">
  None
</button>
<button class="animate-[fadeIn_2s_ease-in-out] bg-color-indigo-500 text-color-white font-bold py-2 px-4 rounded mt-4">
  Custom
</button>`
      }
    }
  ],
  htmlData: [
    {
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">animate-spin</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">animate-ping</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">animate-pulse</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">animate-bounce</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">animate-none</code>, or <code class="text-color-gray-800 dark:text-color-white font-semibold">animate-[value]</code> for custom animations.
      </p>
      <div class="flex gap-4">
        <button class="flex items-center gap-2 bg-color-blue-500 text-color-white font-bold py-2 px-4 rounded">
          <div class="animate-spin size-5 rounded-full border-4 border-color-white/50 border-t-color-white"></div>
          Spin
        </button>
        <button class="flex items-center gap-2 bg-color-white border border-color-gray-200 text-color-gray-600 font-bold py-2 px-4 rounded relative">
            <span class="absolute top-0 right-0 -mt-1 -mr-1 flex size-3">
                <span class="absolute inline-flex h-full w-full animate-ping rounded-full bg-color-sky-400 opacity-75"></span>
                <span class="relative inline-flex size-3 rounded-full bg-color-sky-500"></span>
            </span>
          Ping
        </button>
        <button class="animate-pulse bg-color-yellow-500 text-color-white font-bold py-2 px-4 rounded">
          Pulse
        </button>
        <button class="animate-bounce bg-color-red-500 text-color-white font-bold py-2 px-4 rounded">
          Bounce
        </button>
        <button class="animate-[fadeIn_2s_ease-in-out] bg-color-indigo-500 text-color-white font-bold py-2 px-4 rounded">
          Custom
        </button>
      </div>
      `
    }
  ]
};

export default animation;
<div className="animate-spin animate-[fadeIn_2s_ease-in-out] animate-pulse animate-bounce bg-color-red-500 bg-color-yellow-500 absolute top-0 right-0 -mt-1 -mr-1 flex size-3  size-5 rounded-full border-4 border-color-white/50 border-t-color-white">
<span class="relative flex size-3">
                <span class="absolute inline-flex h-full w-full animate-ping rounded-full bg-color-sky-400 opacity-75"></span>
                <span class="relative inline-flex size-3 rounded-full bg-color-sky-500"></span>
            </span>
</div>